import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { getUser } from "../feature/user/UserActions";
import Footer from "./Footer";
import { MainContainer } from "./MainLayout.styled";
import TopNav from "./TopNav";

const MainLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUser({}));
  }, [dispatch]);

  useEffect(() => {
    if (localStorage.getItem("token") === null) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <MainContainer>
      <TopNav />
      <Outlet />
      <Footer />
    </MainContainer>
  );
};

export default MainLayout;
